// 경로는 /api 접두사를 포함한다(동일 출처 상대 경로, VITE_API_BASE가 있으면 그 앞에 붙는다).
export const ep = {
  appSettings: (q: { build?: number; platform: string }) => {
    const sp = new URLSearchParams();
    if (q.build !== undefined) sp.set("build", String(q.build));
    sp.set("platform", q.platform);
    return `/api/app/settings?${sp.toString()}`;
  },
  authGoogle: "/api/auth/google",
  authGoogleWeb: "/api/auth/google/web",
  authApple: "/api/auth/apple",
  authRefresh: "/api/auth/refresh",
  authLogout: "/api/auth/logout",
  me: "/api/me",
  meBricks: "/api/me/bricks",
  meConversations: "/api/me/conversations",
  meCouponRedeem: "/api/me/coupons/redeem",
  meSettings: "/api/me/settings",
  mePushTokens: "/api/me/push-tokens",
  mePushToken: (token: string) => `/api/me/push-tokens/${encodeURIComponent(token)}`,
  meConsents: "/api/me/consents",
  meBirthDate: "/api/me/birth-date",
  meProfiles: "/api/me/profiles",
  meProfile: (id: string) => `/api/me/profiles/${encodeURIComponent(id)}`,
  mePhotoUrl: "/api/me/photo-url",
  plots: (q: { cursor?: string | null; limit?: number } = {}) => {
    const sp = new URLSearchParams();
    if (q.cursor) sp.set("cursor", q.cursor);
    if (q.limit !== undefined) sp.set("limit", String(q.limit));
    const s = sp.toString();
    return s ? `/api/plots?${s}` : "/api/plots";
  },
  plot: (id: string) => `/api/plots/${encodeURIComponent(id)}`,
  conversations: (plotId: string) => `/api/conversations?plotId=${encodeURIComponent(plotId)}`,
  conversation: (conversationId: string) => `/api/conversations/${encodeURIComponent(conversationId)}`,
  messages: (conversationId: string) => `/api/conversations/${encodeURIComponent(conversationId)}/messages`,
  turns: (conversationId: string) => `/api/conversations/${encodeURIComponent(conversationId)}/turns`,
  reroll: (conversationId: string, turnId: string) => `/api/conversations/${encodeURIComponent(conversationId)}/turns/${encodeURIComponent(turnId)}/reroll`,
  suggestions: (conversationId: string) => `/api/conversations/${encodeURIComponent(conversationId)}/suggestions`,
} as const;
